import { createBrowserRouter } from "react-router-dom";

import AcceptInvitePage from "../auth/AcceptInvitePage";
import ApproveProfileUpdatePage from "../auth/ApproveProfileUpdatePage";
import InvitePage from "../auth/InvitePage";
import LoginPage from "../auth/LoginPage";
import ResetPage from "../auth/ResetPage";
import AuthRoutes from "./AuthRoutes";

const Router = createBrowserRouter([
  {
    path: "/accept-invite",
    element: <AcceptInvitePage />,
  },
  {
    path: "/approve-profile-update",
    element: <ApproveProfileUpdatePage />,
  },
  {
    path: "/reset",
    element: <ResetPage />,
  },
  {
    path: "/invite",
    element: <InvitePage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/*",
    element: <AuthRoutes />,
  },
]);

export default Router;
